import { FC, ReactNode, SyntheticEvent } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import clsx from 'clsx'

export const NO_PERMISSION_MESSAGE = "You don't have permission to access this."
export const VIEW_ONLY_MESSAGE = "You have view-only access here. Contact your administrator if you need to edit."

type Props = {
  allowed: boolean
  children: ReactNode
  /** Layout classes for the wrapper when access is denied (e.g. "d-block w-100"). */
  className?: string
  placement?: 'top' | 'bottom' | 'left' | 'right'
}

const blockInteraction = (event: SyntheticEvent) => {
  event.preventDefault()
  event.stopPropagation()
}

/**
 * Renders children as-is when allowed; otherwise shows them faded (keeping
 * their colours), blocks clicks/keyboard activation and explains why on hover.
 */
const PermissionGate: FC<Props> = ({ allowed, children, className = 'd-inline-block', placement = 'top' }) => {
  if (allowed) {
    return <>{children}</>
  }

  return (
    <OverlayTrigger placement={placement} overlay={<Tooltip>{NO_PERMISSION_MESSAGE}</Tooltip>}>
      <span
        className={clsx(className, 'opacity-75 cursor-not-allowed')}
        aria-disabled="true"
        onClickCapture={blockInteraction}
        onKeyDownCapture={(event) => event.key === 'Enter' && blockInteraction(event)}
      >
        {children}
      </span>
    </OverlayTrigger>
  )
}

export default PermissionGate
